import { Component } from '@angular/core';

@Component({
    selector: 'app-condition',
    templateUrl: './condition.component.html',
    standalone: false
})
export class ConditionComponent {
  hasChildRoute = false;

  constructor() {}

  ngOnInit() {
  }
}
